<div class="verifying-session">
    <div class="verifying-session__content">
        <div class="verifying-session__spinner"></div>
        <h2 class="verifying-session__title">Verifying session...</h2>
        <p class="verifying-session__description">Please wait while we authenticate you.</p>
    </div>
</div>
